import { atom } from 'jotai';

export interface RevenueDateRange {
  startDate: string;
  endDate: string;
}

function formatDateToYYYYMMDD(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function currentMonthRange(): RevenueDateRange {
  const today = new Date();
  return {
    startDate: formatDateToYYYYMMDD(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: formatDateToYYYYMMDD(new Date(today.getFullYear(), today.getMonth() + 1, 0)),
  };
}

/** Date range shared by every revenue page, so switching tabs keeps it. */
export const revenueDateRangeAtom = atom<RevenueDateRange>(currentMonthRange());
